import { ROUTES } from "./routes"

export const OurCapabilitiesPublicRoutesAccess = (currentPath) => {
    return true
}

export const allowedPublicAccess = (currentPath) => {
    let baseURLCrp = process.env.REACT_APP_CRP_BASE_URL?.replace("/api/v1", "")
    if (currentPath === ROUTES.CRP_OAUTH_LOGIN) {
        return true
    }
    if (currentPath === ROUTES.VIDEO) {
        return true
    }
    if (currentPath === ROUTES.PHYSICIAN_VIDEO) {
        return true
    }
    else if (document.referrer.includes(baseURLCrp)) {
        return true
    }
    else if(currentPath.startsWith(ROUTES.POLICY_DOCUMENTS.PUBLIC_ROOT)){
        return true
    }
    else if(currentPath.startsWith(ROUTES.POLICY_DOCUMENTS.PUBLIC_ROOT_V2)){
        return true
    }   
    else if (currentPath === ROUTES.PROPOSAL_TEMPLATE_PREVIEW) {
        return true
    }
    else if (currentPath === ROUTES.PROPOSAL_TEMPLATE) {
        return true
    }
    else if (currentPath === ROUTES.PROPOSAL_TEMPLATE_END_CLIENT) {
        return true
    }
    else if (currentPath === ROUTES.PITCH_DECK.ROOT || currentPath === `${ROUTES.PITCH_DECK.ROOT}/${ROUTES.PITCH_DECK.DETAILS}/${ROUTES.PITCH_DECK.VIEW_DETAILS}` || currentPath === `${ROUTES.PITCH_DECK.ROOT}/${ROUTES.PITCH_DECK.DETAILS}`) {
        return true
    }
    else if (currentPath === `${ROUTES.PITCH_DECK.ROOT}${ROUTES.PITCH_DECK.V2}` || currentPath === `${ROUTES.PITCH_DECK.ROOT}${ROUTES.PITCH_DECK.V2}/${ROUTES.PITCH_DECK.DETAILS}/${ROUTES.PITCH_DECK.VIEW_DETAILS}` || currentPath === `${ROUTES.PITCH_DECK.ROOT}${ROUTES.PITCH_DECK.V2}/${ROUTES.PITCH_DECK.DETAILS}`) {
        return true
    }
    else if (currentPath === `${ROUTES.PITCH_DECK.ROOT}/${ROUTES.PITCH_DECK.MOBILE}` || currentPath === `${ROUTES.PITCH_DECK.ROOT}/${ROUTES.PITCH_DECK.MOBILE}/${ROUTES.PITCH_DECK.DETAILS}/${ROUTES.PITCH_DECK.VIEW_DETAILS}` || currentPath === `${ROUTES.PITCH_DECK.ROOT}/${ROUTES.PITCH_DECK.MOBILE}/${ROUTES.PITCH_DECK.DETAILS}`) {
        return true
    }
    else if (currentPath === `${ROUTES.COLLABORATION_PROPOSITION.ROOT}` || currentPath === `${ROUTES.COLLABORATION_PROPOSITION.ROOT}/${ROUTES.COLLABORATION_PROPOSITION.DETAILS}`) {
        return true
    }

    else if (currentPath.split('/').includes(ROUTES.PROPOSAL_TEMPLATE.replace("/", "")) && currentPath.split('/').includes(ROUTES.DETAIL_PROPOSAL)) {
        return true
    }
    else if (currentPath.includes(ROUTES.CASE_STUDY.ROOT)) {
        return true
    }
    else if (currentPath.includes(ROUTES.OUR_CAPABILITIES.OUR_CAPABILITIES_LABEL) || currentPath.includes("v2/our_capabilities")) {
        return OurCapabilitiesPublicRoutesAccess(currentPath)
    }
    else if (currentPath.includes(ROUTES.ONBOARDING_CLIENT.UNIQUE_FROM_CRP)) {
        return true;
    }
    else if (currentPath.includes(ROUTES.SEPERATE_OUR_CAPABILITIES_PROGRAMMING) || currentPath.includes(ROUTES.SEPERATE_OUR_CAPABILITIES_SCREENSHARE) || currentPath.includes(ROUTES.SEPERATE_OUR_CAPABILITIES_VISUALIZATION)) {
        return true
    }
    else if (currentPath.includes(ROUTES.PRICING_MATRIX.ROOT) ||
        currentPath.includes(ROUTES.PRICING_MATRIX.PRICING_MATRIX_STEP.PRICE_CHART) ||
        currentPath.includes(ROUTES.PRICING_MATRIX.PRICING_MATRIX_STEP.PRICING_ESTIMATE)) {
        return true
    }
    // else if (currentPath.includes(`${ROUTES.ONBOARDING_CLIENT.ONBOARDING_WITHOUT_FORMS}`)){
    //     return true;
    // }
    else return false
}